export const marketingVisible = marketing => marketing && marketing.style.display !== 'none';

const removeMarketingCurtain = () => {
  const marketingCurtain = document.getElementById('top-left-rail-marketing-curtain');
  if(marketingVisible(marketingCurtain)) marketingCurtain.style.display = 'none';
}

export default removeMarketingCurtain;
